
































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CustomDiagram extends Vue {
  @Prop() readonly subSlide!: any;
  @Prop({ default: false }) readonly hideTitle!: boolean;

  setDiagramType(diagramType: string) {
    this.subSlide.diagramType = diagramType;

    // Rensa extra serier för cirkeldiagram
    // if (diagramType === 'pie') {
    //   this.subSlide.series2 = '';
    //   this.subSlide.series3 = '';
    //   this.subSlide.values2 = Array(12).fill(null);
    //   this.subSlide.values3 = Array(12).fill(null);
    // }

    this.onUpdate();
  }

  handleNumberInput(event: any, fieldName: string, index: number) {
    const value = event.target.value;

    // Convert empty string to null, otherwise parse as number
    const numericValue = value === '' ? null : parseFloat(value);

    // Update the appropriate field
    if (fieldName === 'values1') {
      this.subSlide.values1[index] = numericValue;
    } else if (fieldName === 'values2') {
      this.subSlide.values2[index] = numericValue;
    } else if (fieldName === 'values3') {
      this.subSlide.values3[index] = numericValue;
    }

    this.onUpdate();
  }

  onUpdate() {
    this.$emit('update');
  }
}
